<template>
	<section class="content">
		<BlogList />
	</section>
</template>

<script>
// @ is an alias to /src
import BlogList from '@/components/BlogList.vue';

export default {
	name: 'home',
	components: {
		BlogList,
	},
};
</script>

<style lang="scss" scoped>
// .content {
// 	background: $primary;
// 	color: white;
// 	min-height: 100%;
// }
</style>

